import Banner from "../components/Banner";
import FormSponsor from "../components/FormSponsor";
export default function PageSponsorForm() {
  return (
    <>
      <Banner altBG="img/bg-banner-alt-2027.webp" className="bg-white-after">
        <div className="col-12 mb-3">
          <div className="display-1 color-white">Sponsorship Opportunities</div>
        </div>
        <div className="col-12 col-md-9 col-lg-8 col-xl-7 mb-2">
          <p className="color-white mb-0">
            As a FinComp sponsor, you have complete access to all educational
            sessions, meals, and events. We encourage you to meet, network, and
            learn with attendees to understand their challenges and successes
            firsthand.
          </p>
        </div>
      </Banner>

      <section>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <FormSponsor />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
